import { makeStyles } from '@material-ui/core'

export const useStyles = makeStyles((theme) => ({
  container: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    width: '100%',
    padding: '32px 0px',
  },
  illu: {
    width: 98,
    maxWidth: '100%',
    marginRight: 40,
  },
  title: {
    color: theme.palette.primary.main,
  },
}))

export default useStyles
